import { RefreshIcon, StyledIconButton } from "@aureskonnect/react-ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";

import {
    generalConfigStore,
    setMessagePromoCode,
    setMessageGifts,
    setMessageRewards,
    setPictureButton,
} from "@store";

import { SwiperLanguagesWrapper } from "@components/Common/Design/SwiperLanguagesWrapper";

import { TableContent } from "./TableContent";

export function Translation(): JSX.Element {
    const { t } = useTranslation();
    const { project } = useSnapshot(generalConfigStore);
    const resetScanEnterPromoCodeMessage = (((project.template.pages.subSteps[
        "customerBenefit"
    ] as unknown) as CustomerBenefitPageType)
        .options as CustomerBenefitOptionsType).promoCode as RewardType;
    const resetGiftsMessage = (((project.template.pages.subSteps[
        "customerBenefit"
    ] as unknown) as CustomerBenefitPageType)
        .options as CustomerBenefitOptionsType).gifts as RewardType;
    const resetRewardsMessage = (((project.template.pages.subSteps[
        "customerBenefit"
    ] as unknown) as CustomerBenefitPageType)
        .options as CustomerBenefitOptionsType).rewards as RewardType;

    const actionButtonsBenefitsClient = ((project.template.pages.subSteps[
        "customerBenefit"
    ] as unknown) as CustomerBenefitPageType)
        .actionsButtons as CustomerBenefitActionsButtonsType;

    function handleResetLanguagesTranslationsOnClickEvent() {
        const resetLocalScanEnterPromoCodeMessage: RefactoredLanguageType = Object.entries(
            resetScanEnterPromoCodeMessage.languages
        ).reduce((prev: any, [key, _]: any) => {
            return {
                ...prev,
                [key]: t(`${resetScanEnterPromoCodeMessage.resetContent}`, {
                    lng: key,
                }),
            };
        }, {});
        setMessagePromoCode(resetLocalScanEnterPromoCodeMessage);
        const resetLocalGiftsMessage: RefactoredLanguageType = Object.entries(
            resetGiftsMessage.languages
        ).reduce((prev: any, [key, _]: any) => {
            return {
                ...prev,
                [key]: t(`${resetGiftsMessage.resetContent}`, {
                    lng: key,
                }),
            };
        }, {});
        setMessageGifts(resetLocalGiftsMessage);
        const resetLocalRewardsMessage: RefactoredLanguageType = Object.entries(
            resetRewardsMessage.languages
        ).reduce((prev: any, [key, _]: any) => {
            return {
                ...prev,
                [key]: t(`${resetRewardsMessage.resetContent}`, {
                    lng: key,
                }),
            };
        }, {});
        setMessageRewards(resetLocalRewardsMessage);

        Object.values(actionButtonsBenefitsClient).forEach((valuePicture) => {
            const resetLocalPictureContent: RefactoredLanguageType = Object.entries(
                valuePicture.languages
            ).reduce((prev: any, [key, _]: any) => {
                return {
                    ...prev,
                    [key]: t(`${valuePicture.resetContent}`, {
                        lng: key,
                    }),
                };
            }, {});

            setPictureButton(valuePicture.id, resetLocalPictureContent);
        });
    }

    return (
        <div
            className="mt-3 rounded border mx-2"
            style={{
                borderColor: "#CECECE",
                height:"300px"
            }}
        >
            <div
                className="d-flex justify-content-between align-items-center"
                style={{
                    backgroundColor: "#EDEDED",
                    height: "40px",
                    fontSize: "20px",
                }}
            >
                <div className="text-left px-4 d-flex align-items-center  cursor__clz">
                    {t("Translation")}
                </div>
                <StyledIconButton
                    title={t("Reset")}
                    className="m-0"
                    onClick={() => {
                        handleResetLanguagesTranslationsOnClickEvent();
                    }}
                >
                    <RefreshIcon height={15} width={15} />
                </StyledIconButton>
            </div>
            <div className="p-2" style={{ width: "798px" }}>
                <SwiperLanguagesWrapper />

                <TableContent />
            </div>
        </div>
    );
}
